import React from "react";
import { Wallet } from "lucide-react";

export default function WalletLogo({ className = "", alt = "Wallet" }) {
  const cls = ["ems-wallet-logo", className].filter(Boolean).join(" ");
  return (
    <span className={cls} role="img" aria-label={alt}>
      <Wallet size={28} strokeWidth={2.25} aria-hidden="true" />
    </span>
  );
}
